import * as Sentry from '@sentry/react';
import { useCallback } from 'react';
import { getToken } from '../../../services/user-auth';
import { useAiCopilot } from '../context/use-ai-copilot';

export function useChatFeedback() {
  const { chat } = useAiCopilot();

  const submitFeedback = useCallback(
    (messageId: string, feedback: 'Up' | 'Down') => {
      fetch(`${import.meta.env.VITE_WEFT_API}/reports/chat/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          chatId: chat.id,
          messageId,
          feedback,
        }),
      }).catch((error) => {
        Sentry.captureException(error);
      });
    },
    [chat.id],
  );

  return { submitFeedback };
}
